import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { EventPageType } from '@graphql/generated';

export const useIsPhotoUploadFromCollectionEnabled = (pageType?: EventPageType) => {
  // we only support photo upload from collection for custom pages
  // other page types use the old file stack upload
  const [isFeatureEnabled] = useIsFeatureEnabled('photoUploadFromCollectionEnabled', { skip: pageType !== EventPageType.custom });

  return isFeatureEnabled;
};
